module.exports = __webpack_public_path__ + "media/images/lesson_5/edgar_exagerado-f957c952a45f74f5a25ef54f97da5bca.png";